(function () {
  if (window.vpEvolutionLineupReady) return;
  window.vpEvolutionLineupReady = true;

  var mobile = window.matchMedia('(max-width: 991px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var RESUME_DELAY = 6000;

  function pauseOnInteraction(event) {
    var list = event.target.closest ? event.target.closest('[data-vp-el-autoplay]') : null;
    if (list) list.vpElPausedUntil = Date.now() + RESUME_DELAY;
  }

  ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
    document.addEventListener(type, pauseOnInteraction, { passive: true });
  });

  function isOnScreen(element) {
    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function advance(list) {
    var item = list.firstElementChild;
    if (!item) return;
    var step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).columnGap) || 0);
    var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    list.scrollTo({ left: atEnd ? 0 : list.scrollLeft + step, behavior: 'smooth' });
  }

  setInterval(function () {
    if (!mobile.matches || reducedMotion.matches || document.hidden) return;
    var now = Date.now();

    document.querySelectorAll('[data-vp-el-autoplay]').forEach(function (list) {
      var delay = parseFloat(list.getAttribute('data-vp-el-autoplay')) * 1000 || 4000;
      var paused = (list.vpElPausedUntil || 0) > now || list.contains(document.activeElement) || !isOnScreen(list);

      if (paused || !list.vpElNextAt) {
        list.vpElNextAt = now + delay;
        return;
      }
      if (now < list.vpElNextAt) return;

      list.vpElNextAt = now + delay;
      advance(list);
    });
  }, 500);
})();
